import apiClient from "@/axiosConfig";
import { useUxStore } from "@/stores/uxStore";

const getUxStore = () => useUxStore();

export default {
  async getCurrent() {
    try {
      getUxStore().startLoading();
      return await apiClient.get("/user/api-pricing-help");
    } catch (error) {
      console.error("Error in ApiPricingHelpService.getCurrent:", error);
      getUxStore().setError("Fehler beim Laden der API-Preisübersicht.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },
};
